import { render, staticRenderFns } from "./ExaminePerson.vue?vue&type=template&id=06c55b72&scoped=true&"
import script from "./ExaminePerson.vue?vue&type=script&lang=js&"
export * from "./ExaminePerson.vue?vue&type=script&lang=js&"
import style0 from "./ExaminePerson.vue?vue&type=style&index=0&id=06c55b72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c55b72",
  null
  
)

export default component.exports